













import { Component, Vue, Prop } from 'vue-property-decorator';

import { IText } from './types';

@Component
export default class TextBlock extends Vue implements IText {
  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: Boolean, default: false })
  readonly info!: boolean;

  @Prop({ type: String, default: '' })
  readonly infoText!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/certificate/components/data/components/text/Text.vue